<a [attr.aria-label]="
  'miniCart.item' | cxTranslate: { count: count$ | async }" (click)="openDialog()">
  <span class="cart-icon">
    <cx-icon type="CART_BLUE"></cx-icon>
    @if (authService.isUserLoggedIn() | async) {
      @if (count$ | async; as count) {
        <span class="count">{{ 'miniCart.count' | cxTranslate: {count: count} }}</span>
      }
    }
  </span>

  @if (displayCustomerPrices$ | async) {
    <span class="mini-cart-second-row">
      <span class="total">{{ 'miniCart.total' | cxTranslate: {total: subTotal$ | async} }}</span>
    </span>
  }

  <cx-icon type="ARROW_EXPAND_DOWN"
  [ngClass]="{'mini-cart-dialog-toggle-icon' : miniCartDialogOpen$ | async}"></cx-icon>
</a>